/* eslint-disable react/prop-types */
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import IconButton from '@material-ui/core/IconButton'
import Popover from '@material-ui/core/Popover'
import TextField from '@material-ui/core/TextField'
import Tooltip from '@material-ui/core/Tooltip'
import FilterListIcon from '@material-ui/icons/FilterList'
import SearchIcon from '@material-ui/icons/Search'
import PopupState, { bindPopover, bindTrigger } from 'material-ui-popup-state'
import React, { useEffect, useState } from 'react'
import { ValidatorForm } from 'react-material-ui-form-validator'

import BadgeGlobal from '../../components/Badge'
import { fetchBillingType } from '../BillingTypeActions'
import BaseFilter from '../../../components/hooks/BaseFilter'
import filterStylesComponents from '../../../assets/filterComponentsStyles'
import Icon from '@mdi/react'
import {
  mdiFileEdit,
  mdiMagnifyExpand,
  mdiMicrosoftExcel,
  mdiNoteEditOutline,
} from '@mdi/js'
import { InputAdornment } from '@material-ui/core'
import colors from '../../../assets/colors'
import { useQueryParams } from '../../../util/utils'
import { useSelector } from 'react-redux'
import { usePermissions } from '../../../hooks/usePermission'
import {
  Link,
  useHistory,
  useLocation,
} from 'react-router-dom/cjs/react-router-dom'

export default function Filter(props) {
  const permissionUser = useSelector(state => state.auth.permissionUser)
  const { canCreate } = usePermissions()

  const location = useLocation()
  const history = useHistory()

  const filters = useQueryParams(location.search)

  const classes = filterStylesComponents()

  const onSubmit = (data = filters) => {
    const searchParams = new URLSearchParams(data)
    searchParams.set('page', 1)
    history.push(`${location?.pathname}?${searchParams?.toString()}`)
  }

  const handleSubmit = e => {
    e.preventDefault()

    const formData = e.currentTarget
    const data = new FormData(formData)
    const entries = data.entries()
    const values = Object.fromEntries(entries)

    onSubmit({ ...filters, ...values })
  }

  return (
    <BaseFilter>
      <Grid container spacing={2}>
        <Grid item xs={4}>
          <form style={{ width: '100%' }} onSubmit={handleSubmit}>
            <TextField
              label="Filtre por nome"
              className={classes.inputFilter}
              fullWidth
              name="name"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton type="submit">
                      <Icon path={mdiMagnifyExpand} size={1} />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              defaultValue={filters?.name}
            />
          </form>
        </Grid>

        <Grid item xs className={classes.areaButtons}>
          {canCreate('centro-custo', permissionUser) && (
            <IconButton
              className={classes.btnAdd}
              component={Link}
              to={`/billing-type/new${location.search}`}
            >
              <Icon path={mdiNoteEditOutline} size={1} />
              Cadastar
            </IconButton>
          )}
        </Grid>
      </Grid>
    </BaseFilter>
  )
}
